import React, { Component } from 'react';
import AmazonPreview from '../../assets/landing/amazon-preview.jpg';

import '../../static/register/AmazonReadyToBegin.css';
import DeviceHelper from '../../functions/device';

export default class GlobalHeader extends Component {
	render() {

		return (
			<header className={`amazon landing-header z-depth-0${DeviceHelper.isMobile ? " alida-mobile-header" : ""}`}>
				<nav className="landing-header-container-web z-depth-0 height-auto">
					<img className="landing-header-logo noselect width-100p" src={AmazonPreview} alt='Amazon Preview' />
				</nav>
			</header>
		);
	}
}


// WEBPACK FOOTER //
// ./src/components/global/AmazonAlidaHeader.js